function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { isNode, isPair } from '../nodes/identity.js';
import { stringify } from './stringify.js';
import { lineComment, indentComment } from './stringifyComment.js';

function stringifyCollection(collection, ctx, options) {
  var _ctx$inFlow;

  var flow = (_ctx$inFlow = ctx.inFlow) !== null && _ctx$inFlow !== void 0 ? _ctx$inFlow : collection.flow;
  var stringify = flow ? stringifyFlowCollection : stringifyBlockCollection;
  return stringify(collection, ctx, options);
}

function stringifyBlockCollection(_ref, ctx, _ref2) {
  var comment = _ref.comment,
      items = _ref.items;
  var blockItemPrefix = _ref2.blockItemPrefix,
      flowChars = _ref2.flowChars,
      itemIndent = _ref2.itemIndent,
      onChompKeep = _ref2.onChompKeep,
      onComment = _ref2.onComment;
  var indent = ctx.indent,
      commentString = ctx.options.commentString;
  var itemCtx = Object.assign({}, ctx, {
    indent: itemIndent,
    type: null
  });
  var chompKeep = false; // flag for the preceding node's status

  var lines = [];

  for (var i = 0; i < items.length; ++i) {
    var item = items[i];
    var _comment = null;

    if (isNode(item)) {
      if (!chompKeep && item.spaceBefore) lines.push('');
      addCommentBefore(ctx, lines, item.commentBefore, chompKeep);
      if (item.comment) _comment = item.comment;
    } else if (isPair(item)) {
      var ik = isNode(item.key) ? item.key : null;

      if (ik) {
        if (!chompKeep && ik.spaceBefore) lines.push('');
        addCommentBefore(ctx, lines, ik.commentBefore, chompKeep);
      }
    }

    chompKeep = false;

    var _str = stringify(item, itemCtx, function () {
      return _comment = null;
    }, function () {
      return chompKeep = true;
    });

    if (_comment) _str += lineComment(_str, itemIndent, commentString(_comment));
    if (chompKeep && _comment) chompKeep = false;
    lines.push(blockItemPrefix + _str);
  }

  var str;

  if (lines.length === 0) {
    str = flowChars.start + flowChars.end;
  } else {
    str = lines[0];

    for (var _i = 1; _i < lines.length; ++_i) {
      var line = lines[_i];
      str += line ? "\n".concat(indent).concat(line) : '\n';
    }
  }

  if (comment) {
    str += '\n' + indentComment(commentString(comment), indent);
    if (onComment) onComment();
  } else if (chompKeep && onChompKeep) onChompKeep();

  return str;
}

function stringifyFlowCollection(_ref3, ctx, _ref4) {
  var items = _ref3.items;
  var flowChars = _ref4.flowChars,
      itemIndent = _ref4.itemIndent;
  var indent = ctx.indent,
      indentStep = ctx.indentStep,
      fcPadding = ctx.flowCollectionPadding,
      commentString = ctx.options.commentString;
  itemIndent += indentStep;
  var itemCtx = Object.assign({}, ctx, {
    indent: itemIndent,
    inFlow: true,
    type: null
  });
  var reqNewline = false;
  var linesAtValue = 0;
  var lines = [];

  for (var i = 0; i < items.length; ++i) {
    var item = items[i];
    var comment = null;

    if (isNode(item)) {
      if (item.spaceBefore) lines.push('');
      addCommentBefore(ctx, lines, item.commentBefore, false);
      if (item.comment) comment = item.comment;
    } else if (isPair(item)) {
      var ik = isNode(item.key) ? item.key : null;

      if (ik) {
        if (ik.spaceBefore) lines.push('');
        addCommentBefore(ctx, lines, ik.commentBefore, false);
        if (ik.comment) reqNewline = true;
      }

      var iv = isNode(item.value) ? item.value : null;

      if (iv) {
        if (iv.comment) comment = iv.comment;
        if (iv.commentBefore) reqNewline = true;
      } else if (item.value == null && ik !== null && ik !== void 0 && ik.comment) {
        comment = ik.comment;
      }
    }

    if (comment) reqNewline = true;
    var str = stringify(item, itemCtx, function () {
      return comment = null;
    });
    if (i < items.length - 1) str += ',';
    if (comment) str += lineComment(str, itemIndent, commentString(comment));
    if (!reqNewline && (lines.length > linesAtValue || str.includes('\n'))) reqNewline = true;
    lines.push(str);
    linesAtValue = lines.length;
  }

  var start = flowChars.start,
      end = flowChars.end;

  if (lines.length === 0) {
    return start + end;
  } else {
    if (!reqNewline) {
      var len = lines.reduce(function (sum, line) {
        return sum + line.length + 2;
      }, 2);
      reqNewline = ctx.options.lineWidth > 0 && len > ctx.options.lineWidth;
    }

    if (reqNewline) {
      var _str2 = start;

      var _iterator = _createForOfIteratorHelper(lines),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var line = _step.value;
          _str2 += line ? "\n".concat(indentStep).concat(indent).concat(line) : '\n';
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return "".concat(_str2, "\n").concat(indent).concat(end);
    } else {
      return "".concat(start).concat(fcPadding).concat(lines.join(' ')).concat(fcPadding).concat(end);
    }
  }
}

function addCommentBefore(_ref5, lines, comment, chompKeep) {
  var indent = _ref5.indent,
      commentString = _ref5.options.commentString;
  if (comment && chompKeep) comment = comment.replace(/^\n+/, '');

  if (comment) {
    var ic = indentComment(commentString(comment), indent);
    lines.push(ic.trimStart()); // Avoid double indent on first line
  }
}

export { stringifyCollection };